var _defs, _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgNavyBeams(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 40,
    y1: 48,
    x2: 1208,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04263A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01111B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "beam1",
    x1: 114,
    y1: 0,
    x2: 516,
    y2: 584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CD1D1",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CD1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "beam2",
    x1: 0,
    y1: 456,
    x2: 652,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13C7D2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13C7D2",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 494L398 0H714L176 720H0V494Z",
    fill: "url(#beam1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M342 720L930 0H1122L548 720H342Z",
    fill: "url(#beam2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 602L620 0H770L124 720H0V602Z",
    fill: "#0A4150",
    fillOpacity: 0.24
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M504 720L1116 104V280L700 720H504Z",
    fill: "#3AE4E4",
    fillOpacity: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNavyBeams);
export default __webpack_public_path__ + "static/media/bg-navy-beams.a0c678c02062b73ecb76e7110337da1f.svg";
export { ForwardRef as ReactComponent };